import { render, staticRenderFns } from "./DocumentAttachFooterRoomComponents.vue?vue&type=template&id=ed530eba&scoped=true&"
import script from "./DocumentAttachFooterRoomComponents.vue?vue&type=script&lang=js&"
export * from "./DocumentAttachFooterRoomComponents.vue?vue&type=script&lang=js&"
import style0 from "./DocumentAttachFooterRoomComponents.vue?vue&type=style&index=0&id=ed530eba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.10.1_@vue+compiler-sfc@3.5.29_babel-core@7.0.0-bridge.0_@babel+core@7.24._f07fc21c0eeec7f6e04fb4ae2769cbbc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed530eba",
  null
  
)

export default component.exports